import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AppModel } from '../../../nextray/Models/AppModel';
import { VwBaseComponent } from '../shared';
import { VwDefMechanicalComponent } from './vw-def-mechanical';


/**
 * Deformity data of view plan page.
 */
@Component({
	selector: 'vw-deformity',
	templateUrl: './vw-deformity.component.html',
	imports: [
		VwDefMechanicalComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class VwDeformityComponent extends VwBaseComponent {

	model = input.required<AppModel>();
	img = input<string>();

}
